import { StepProps } from "~/components/organisms/step";
import { validateSchema, ValidateType } from "~/schemas/apis/validate-schema";
import { tryCatch } from "./try-catch";

export async function fetchValidate(
  id: string,
  summaryline: string,
  country: string
) {
  const result = await tryCatch(
    fetch(
      `/api/location/validate?query=${summaryline}&country=${country}&id=${id}`
    )
  );

  if (result.error) {
    console.error("Error validating data:", result.error);
    throw result.error;
  }

  return await result.data.json();
}

export function formatValidateData(
  data: unknown,
  summaryline: string
): ValidateType {
  if (!Array.isArray(data) || data.length === 0)
    throw new Error("No data found");

  const parsedItem = validateSchema.parse(data[0]);
  if (!parsedItem) throw new Error("Error parsing data");

  parsedItem.street = summaryline;

  return parsedItem;
}

export function updateAddressValues(
  name: "company" | "site",
  data: ValidateType,
  country: string,
  setValue: StepProps["setValue"]
) {
  setValue(`${name}.address.street`, data.street);
  setValue(`${name}.address.city`, data.posttown);
  setValue(`${name}.address.zipCode`, data.postcode);
  setValue(`${name}.address.country`, country);
}
